import { __awaiter, __generator } from "tslib";
import { gaugeKey } from './';
export var creategaugeDriver = function (wrapper) {
    var base = wrapper.$("." + gaugeKey);
    var isInverse = base.$('.gauge-fill').hasClass('inverse');
    return {
        isColorGreen: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, isInverse];
                case 1: return [2 /*return*/, (_a.sent()) ? base.$('.empty').exists() : base.$('.full').exists()];
            }
        }); }); },
        isColorOrange: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, isInverse];
                case 1: return [2 /*return*/, (_a.sent()) ? base.$('.almost-full').exists() : base.$('.middle-full').exists()];
            }
        }); }); },
        isColorYellow: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, isInverse];
                case 1: return [2 /*return*/, (_a.sent()) ? base.$('.middle-full').exists() : base.$('.almost-full').exists()];
            }
        }); }); },
        isColorRed: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, isInverse];
                case 1: return [2 /*return*/, (_a.sent()) ? base.$('.full').exists() : base.$('.empty').exists()];
            }
        }); }); },
        isEmpty: function () {
            return base.$('.gauge-fill').attr('style').then(function (str) {
                var splited = str && str.split('%')[0];
                var width = splited && splited.split(': ')[1];
                return width === '0';
            });
        },
        getFillWidth: function () {
            return base.$('.gauge-fill').attr('style').then(function (str) {
                var splited = str && str.split('%')[0];
                var width = splited && splited.split(': ')[1];
                return width || '0';
            });
        },
        isInverse: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, isInverse];
        }); }); },
        base: base
    };
};
//# sourceMappingURL=driver.js.map